import React, { useEffect } from 'react';
import { sendLiveRegionMessage } from '../../../../atoms/LiveRegionGlobal/LiveRegionGlobal';
import { LoadingSpinner } from '../../../../atoms/LoadingSpinner';

type ContentWrapperLoadingSpinner = {
  loadingMessage: string;
};

/**
 * Shows a Loading indicator if ContentWrapper is Loading
 */
export default function ContentWrapperLoadingSpinner({ loadingMessage }: ContentWrapperLoadingSpinner) {
  useEffect(() => {
    sendLiveRegionMessage(loadingMessage);
  }, [loadingMessage]);
  return (
    <span className="content-wrapper__spinner">
      <LoadingSpinner />
    </span>
  );
}
